export function normalizeAzimuth(value) {
  const num = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(num)) return null

  const normalized = ((num % 360) + 360) % 360
  return normalized
}

export function azimuthToCompassDirection(azimuth) {
  const normalized = normalizeAzimuth(azimuth)
  if (normalized === null) return null

  const directions = [
    'N',
    'NNE',
    'NE',
    'ENE',
    'E',
    'ESE',
    'SE',
    'SSE',
    'S',
    'SSW',
    'SW',
    'WSW',
    'W',
    'WNW',
    'NW',
    'NNW'
  ]

  const index = Math.round(normalized / 22.5) % 16
  return directions[index]
}

